
import "./Torche.scss";

import { Component } from "react";
import clsx from 'clsx';
import { getPositionFromIndex, objPosition } from '../GameplayUtils';

interface ITuileTorcheProps{    
    index:number;     
}
type TTuileTorcheState = {
    torcheType:number;
}

class TuileTorche extends Component<ITuileTorcheProps,TTuileTorcheState> {

  index:number;    
  position:objPosition = {colonne:0, ligne:"X"};

  state:TTuileTorcheState = this.getInitialState();
  constructor(props:any){
    super(props);
    this.index = props.index;
    this.position = getPositionFromIndex(this.index);
  }
  getInitialState():TTuileTorcheState{
    return{torcheType:1}
  }


  componentDidMount(){ 
    const typeHasard = 1 + Math.floor(Math.random() * 4);
    this.setState({torcheType:typeHasard});
  }

  getClassPosition(){
    return `tuile_pos_x_${this.position.colonne} tuile_pos_y_${this.position.ligne} tuile_type_${this.state.torcheType}`
  }

  
  render() {    
    return (
        <div 
            className={clsx("tuileTorche", this.getClassPosition())}
            data-code={this.state.torcheType}
            data-position={`${this.position.ligne}${this.position.colonne}`}   
            data-colonne={this.position.colonne}   
            data-ligne={this.position.ligne}           
        />
    )
  }
}

export default TuileTorche;
